module.exports = __webpack_public_path__ + "static/media/graduate1.108175ce.png";